import { IMenu } from '@dfl/mui-react-common';
import { ListAlt, MonetizationOnOutlined } from '@mui/icons-material';
import { AUTO_ADJUSTMENT_RULE_PERMISSIONS } from 'modules/conciliation/auto-adjustment-rules/constants';
import { CONCILIATION_ADJUSTMENT_CAUSES_PERMISSIONS } from 'modules/conciliation/conciliation-adjustment-causes/constants';
import { CONCILIATION_PERMISSIONS } from 'modules/conciliation/main/constants';
import { PAYMENT_AGREEMENT_PERMISSIONS } from 'modules/conciliation/payment-agreement/constants';
import { RECONCILIATION_ADJUSTMENT_PERMISSIONS } from 'modules/conciliation/reconciliation-adjustment/constants/reconciliation-adjustment.permissions';
import { REPORTS_PERMISSIONS } from 'modules/dashboard/constant/reports.permissions';

type IConciliationMenu = IMenu & { modulePath?: string; items: any[] };

export const CONCILIATION_MENU: IConciliationMenu[] = [
  {
    title: 'main_menu.admin.section.general.title',
    prefix: '/conciliations',
    atLessOne: true,
    items: [
      {
        title: 'conciliation:list',
        path: '/conciliations/main/general',
        modulePath: '/conciliations/main',
        partialMatch: true,
        icon: <ListAlt fontSize='small' />,
        permissions: [CONCILIATION_PERMISSIONS.CONCILIATION_VIEW, REPORTS_PERMISSIONS.REPORT_CONCILIATION],
        atLessOne: true,
      },
      {
        title: 'reconciliationAdjustment:list',
        path: '/conciliations/reconciliation-adjustment',
        exact: true,
        icon: <MonetizationOnOutlined fontSize='small' />,
        permissions: [RECONCILIATION_ADJUSTMENT_PERMISSIONS.RECONCILIATION_ADJUSTMENT_VIEW],
      },
      {
        title: 'paymentAgreement:list',
        exact: true,
        path: '/conciliations/payment-agreements',
        icon: <MonetizationOnOutlined fontSize='small' />,
        permissions: [PAYMENT_AGREEMENT_PERMISSIONS.PAYMENT_AGREEMENT_VIEW],
      },
    ],
  },
  {
    title: 'main_menu.admin.section.general.settings',
    prefix: '/conciliations',
    atLessOne: true,
    items: [
      {
        title: 'conciliationAdjustmentCauses:list',
        path: '/conciliations/conciliation-adjustment-causes',
        exact: true,
        icon: <ListAlt fontSize='small' />,
        permissions: [CONCILIATION_ADJUSTMENT_CAUSES_PERMISSIONS.CONCILIATION_ADJUSTMENT_CAUSES_VIEW],
      },
      {
        title: 'auto-adjustment-rules:module',
        path: '/conciliations/auto-adjustment-rules',
        exact: true,
        icon: <ListAlt fontSize='small' />,
        permissions: [AUTO_ADJUSTMENT_RULE_PERMISSIONS.AUTO_ADJUSTMENT_VIEW],
      },
    ],
  },
];
